import { Check, Minus, Plus } from 'lucide-react';

export const Stepper = ({ label, value, placeholder, onChange, step, unit, disabled, testId, headerRight }) => (
  <div className="flex-1 min-w-0 rounded-2xl bg-white/[0.04] border border-white/10 px-1.5 py-2" data-testid={testId}>
    <div className="flex items-center justify-center gap-2 mb-1 h-5">
      <p className="text-[10px] uppercase tracking-[0.2em] text-white/40">{label}</p>
      {headerRight}
    </div>
    <div className="grid grid-cols-2 items-center gap-x-3 gap-y-1 sm:gap-x-0.5 sm:grid-cols-[auto_minmax(0,1fr)_auto] sm:gap-0.5">
      <button
        type="button" disabled={disabled} aria-label={`Decrease ${label}`}
        onClick={() => onChange(String(Math.max(0, (Number(value || placeholder) || 0) - step)))}
        className="order-2 sm:order-1 justify-self-end sm:justify-self-auto h-8 w-8 sm:h-9 sm:w-9 shrink-0 rounded-full bg-white/[0.06] text-white flex items-center justify-center active:scale-90 transition-transform disabled:opacity-40"
        data-testid={`${testId}-minus`}
      >
        <Minus className="h-4 w-4" />
      </button>
      <div className="order-1 sm:order-2 col-span-2 sm:col-span-1 flex items-baseline justify-center gap-0.5 min-w-0">
        <input
          type="number" inputMode="decimal" value={value} placeholder={placeholder || '0'} disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          aria-label={label}
          className={`w-full min-w-0 bg-transparent text-center ${String(value || placeholder || '').length > 4 ? 'text-2xl' : 'text-3xl'} font-bold tabular-nums text-white outline-none placeholder:text-white/55 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none`}
          data-testid={`${testId}-input`}
        />
        {unit && !headerRight && <span className="text-xs text-white/40">{unit}</span>}
      </div>
      <button
        type="button" disabled={disabled} aria-label={`Increase ${label}`}
        onClick={() => onChange(String((Number(value || placeholder) || 0) + step))}
        className="order-3 justify-self-start sm:justify-self-auto h-8 w-8 sm:h-9 sm:w-9 shrink-0 rounded-full bg-primary/15 text-primary flex items-center justify-center active:scale-90 transition-transform disabled:opacity-40"
        data-testid={`${testId}-plus`}
      >
        <Plus className="h-4 w-4" />
      </button>
    </div>
  </div>
);

export const SetBubbles = ({ rows, active, onPick }) => (
  <div className="flex items-center gap-2 mb-3 overflow-x-auto -mx-1 px-1 pb-0.5">
    {rows.map((r, i) => (
      <button
        type="button" key={i} onClick={() => onPick(i)}
        className={`shrink-0 h-9 min-w-9 px-2 rounded-full text-sm font-bold tabular-nums transition-[background-color,transform] active:scale-90 ${
          i === active
            ? 'bg-primary text-black'
            : r.logged
              ? 'bg-green-500/15 text-green-400 border border-green-500/40'
              : 'bg-white/[0.05] text-white/50 border border-white/10'
        }`}
        aria-label={`Set ${i + 1}${r.logged ? ' (logged)' : ''}`}
        data-testid={`setlogger-set-bubble-${i + 1}`}
      >
        {r.logged && i !== active ? <Check className="h-4 w-4 mx-auto" /> : i + 1}
      </button>
    ))}
    <span className="ml-auto shrink-0 text-[11px] text-white/40" data-testid="setlogger-done-count">
      {rows.filter((r) => r.logged).length}/{rows.length} done
    </span>
  </div>
);
